<template>
  <v-row>
    <v-simple-table style="width: 100%" class="mt-1">
      <tbody>
        <tr
          v-for="(el, key) in items.filter(f => {
            return f.deleted === undefined;
          })"
          :key="key"
        >
          <td class="text-left">
            <a href="#" @click.prevent="$root.openLink(el)" target="_blank">
              {{ el.name || el.file }}
            </a>
          </td>
          <td width="10px" style="height: 38px">
            <v-btn href="#" @click.prevent="$root.openLink(el)" target="_blank" class="mx-2" fab dark x-small color="error" title="Скачать">
              <v-icon dark> mdi-download </v-icon>
            </v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-row>
</template>

<script>
export default {
  props: {
    value: [Array],
  },
  computed: {
    items: {
      get() {
        if (this.value) {
          try {
            return this.value;
          } catch (error) {}
        }
        return [];
      },
    },
  },
  methods: {},
};
</script>
